<template>
    <div class="d-flex align-items-center flex-column flex-md-row p-2 p-md-5">
        <div class="overlay__img--wrapper">
            <img src="@/assets/milestones/milestone__1924.jpg" class="img-fluid overlay__img">
        </div>
        <div class="milestone__info--overlay">
            <div class="milestone__year font-24 text-left">1924</div>
            <div class="milestone__headline font-bold font-32 text-left" v-html="$t('MILESTONE_1924_HEADLINE')">Shiseido: Geppo cultural information magazine
                for customers
            </div>
            <div class="text-left d-flex flex-column align-items-start mt-3 mt-md-5">
                <div class="milestone__text font-18 mt-4" v-html="$t('MILESTONE_1924_TEXT_01')">
                    This was the first information magazine in the cosmetics industry, and it was distributed through
                    Shiseido's chain stores across the country. Various articles on “How to keep fit to maintain health
                    and youthfulness” and “How to pour coffee” made up the pages of the first issue.The magazine made a
                    great contribution to creating Shiseido's high-class image, introducing abundant information on then
                    unfamiliar foreign trends such as Parisian fashions and hairstyles. The magazine was renamed
                    Shiseido Graph in 1933, and was given its present title, Hanatsubaki, in 1937
                </div>

            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "milestone-1924",
    }
</script>

<style scoped>

</style>